/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiftReceiptURL
 */
export interface GiftReceiptURL {
    /**
     * 
     * @type {string}
     * @memberof GiftReceiptURL
     */
    receipt_url: string | null;
}

/**
 * Check if a given object implements the GiftReceiptURL interface.
 */
export function instanceOfGiftReceiptURL(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "receipt_url" in value;

    return isInstance;
}

export function GiftReceiptURLFromJSON(json: any): GiftReceiptURL {
    return GiftReceiptURLFromJSONTyped(json, false);
}

export function GiftReceiptURLFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiftReceiptURL {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'receipt_url': json['receipt_url'],
    };
}

export function GiftReceiptURLToJSON(value?: GiftReceiptURL | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'receipt_url': value.receipt_url,
    };
}

